<template>
    <ui-modal>
        <template #header>
            <h3 v-text="`Wydawanie worków (${selectedPackages.length})`" />
        </template>

        <h4 v-text="`Lista worków do wydania dla Operatora: ${operatorName}`" />

        <div v-if="selectedPackages.length" class="c-table dispatch-bags-table">
            <div class="c-thead">
                <div v-text="'Frakcja'" class="c-td" />
                <div v-text="'Status'" class="c-td" />
                <div v-text="'Numer plomby'" class="c-td" />
                <div class="c-td">
                    Wartość worka
                    <a-icon
                        v-tooltip="$options.bagValueTooltip"
                        icon="Info"
                        width="16"
                        height="16"
                        style="position: relative; top: 2px"
                    />
                </div>
            </div>

            <div class="c-tbody">
                <div v-for="bag in selectedPackages" class="c-row" :key="bag.id">
                    <dispatch-bag :bag="bag" />
                </div>
            </div>
        </div>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                :disabled="isLoading"
                @click="$emit('close-modal')"
            />
            <the-btn
                class="btn-secondary"
                text="Potwierdź wydanie worków"
                :icon="isLoading ? 'Spinner' : ''"
                :loading-status="isLoading ? 'loading' : 'idle'"
                :disabled="isLoading"
                @click="onConfirm"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FRACTIONS } from '@/utils/constants/drs/fractions'
import DispatchBag from '@/components/drs/stores/bags/DispatchBag.vue'

export default {
    bagValueTooltip: 'Na wartość worka składa się liczba sztuk przemnożona przez opłatę operatora',

    computed: {
        ...mapGetters('drsStores', ['getFilters']),
        ...mapGetters('drsBags', ['deviceHeaders', 'selectedPackages']),

        args() {
            return this.$store.getters.getModal.args
        },

        operatorName() {
            return this.selectedPackages[0]?.selectedOperator?.name || ''
        },

        filterLocationId() {
            return this.getFilters.locationId.value
        }
    },

    data: () => ({
        isLoading: false
    }),

    methods: {
        ...mapActions('drsBags', ['loadPackages', 'resetMode']),

        getFractionData(fractionTypeId) {
            return Object.values(FRACTIONS).find(f => f.id === fractionTypeId) || null
        },

        async onConfirm() {
            if (this.isLoading) {
                return
            }

            try {
                this.isLoading = true
                const { status } = await this.$store.$api.patch('drs/api/proxy/drs/package/transfer', {
                    cashier: this.selectedPackages[0].cashier,
                    comment: '',
                    receiver: this.operatorName,
                    seal_numbers: this.selectedPackages.map(bag => bag.seal_number)
                }, {
                    headers: this.deviceHeaders
                })

                if (status !== 200) {
                    throw new Error('Błąd podczas wydawania worków')
                }

                await this.loadPackages()

                this.resetMode()

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Worki zostały wydane'
                })
                this.$emit('close-modal')
            } catch (error) {
                console.error(error)
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas wydawania worków'
                })
            } finally {
                this.isLoading = false
            }
        }
    },

    components: {
        DispatchBag
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.dispatch-bags-table {
    --gap: 20px;
    .c-thead {
        align-items: flex-start;
        gap: var(--gap);
    }

    .c-tr {
        gap: var(--gap);
    }

    .c-td {
        --width: 25%;
    }

        @include media-breakpoint-down(lg) {
        .c-tr {
            --gap: 8px;
            flex-direction: row;
            align-items: center;
        }
    }

    @include media-breakpoint-down(sm) {
        .c-tr {
            --gap: 8px;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 1rem;
        }
        .c-td {
            --width: calc(50% - var(--gap) / 2);
            padding: 0;
        }
    }
}
</style>